import type { ReactNode } from 'react';
import { DateField } from '@components/ui/DateField/DateField';
import { dateToYmd, ymdToDate } from '@components/ui/DateField/fieldDate';
import styles from './DeliveryOrderForm.module.css';

interface IDateFieldRowProps {
  label: string;
  placeholder: string;
  clearLabel: string;
  /** '' = unset. */
  value: string;
  onChange: (next: string) => void;
  /** The system put this date here — amber until the user changes it. */
  marked?: boolean;
  /** What it replaced, once changed. */
  note?: ReactNode;
  /** Locked because an earlier date in the chain is missing — see the answered
   *  and due fields below. Also hides the clear button: there is nothing to
   *  clear on a field that cannot be set. */
  disabled?: boolean;
  /** The SITE's today ('YYYY-MM-DD') — what the calendar marks and an empty
   *  field opens on. */
  today: string;
}

/** One optional workflow date. ui/DateField's onChange is non-nullable, so an
 *  overlaid clear button is what keeps the field optional — the same pattern the
 *  issues form dialog uses for its due date. */
export function DateFieldRow({
  label, placeholder, clearLabel, value, onChange, marked, note, disabled, today,
}: IDateFieldRowProps) {
  const picked = ymdToDate(value);
  return (
    <div className={styles.field}>
      {/* Not a <label htmlFor>: DateField renders a Popover trigger button whose
          aria-label names the control. */}
      <span className={styles.label}>{label}</span>
      <div className={`${styles.dateWrap}${marked ? ` ${styles.prefilled}` : ''}`}>
        <DateField
          value={picked}
          onChange={(next) => onChange(dateToYmd(next))}
          placeholder={placeholder}
          ariaLabel={label}
          disabled={disabled}
          today={ymdToDate(today)}
          elevated
        />
        {picked && !disabled ? (
          <button
            type="button"
            className={styles.dateClear}
            aria-label={clearLabel}
            onClick={() => onChange('')}
          >
            ×
          </button>
        ) : null}
      </div>
      {note}
    </div>
  );
}
